<template>
  <Modal
    :is-open="isOpen"
    size="md"
    :close-on-backdrop="true"
    :show-close-button="true"
    container-class="max-w-md"
    @close="handleCancel"
    :scrollable="false"
  >
    <div class="flex flex-col items-center justify-center ">
      <div
        class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4"
      >
        <AlertTriangle :size="40" class="text-blue-600" />
      </div>

      <h4 class="text-2xl font-serif font-bold text-gray-900 mb-2 text-center">
        Order Minimum Required
      </h4>

      <p class="text-gray-600 text-center text-sm mb-6">
        The selected option requires a minimum order subtotal. Please add more
        items to your cart to proceed with this service.
      </p>

      <div class="w-full mt-4 pt-4 border-t border-gray-100">
        <p
          class="text-xs text-gray-500 uppercase tracking-wider font-bold mb-2 text-center"
        >
          Required Minimum Subtotal
        </p>
        <p class="text-2xl font-bold text-gray-900 text-center">
          {{ formatPrice(Number(minimumAmount)) }}
        </p>
      </div>

      <div class="w-full mt-6 space-y-3">
        <button
          @click="handleNavigate"
          class="w-full bg-primary-600 text-white font-bold py-3 rounded-xl shadow-lg shadow-primary-600/20 hover:bg-primary-700 transition-all active:scale-[0.98]"
        >
          Add More Items
        </button>

        <button
          @click="handleCancel"
          class="w-full text-gray-600 font-bold py-3 rounded-xl hover:bg-gray-100 transition-all"
        >
          Stay with Current Option
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "./ui/Modal.vue";
import { AlertTriangle } from "lucide-vue";

export default {
  name: "MinimumOrderModal",
  components: {
    Modal,
    AlertTriangle
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    minimumAmount: {
      type: [Number, String],
      required: true
    },
    currencySymbol: {
      type: String,
      default: "$"
    }
  },
  computed: {
    ...mapGetters(["formatPrice"])
  },
  methods: {
    handleNavigate() {
      this.$emit("navigate-to-order");
      this.$emit("close");
    },
    handleCancel() {
      this.$emit("close");
    }
  }
};
</script>
